export default function launchAppScheme(url) {
  const demo = process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DEMO === 'true';
  if (demo && String(url).startsWith('aex:')) {
    return;
  }
  window.location.href = url;
}
